import Vue from 'vue'
import VueRouter from 'vue-router'
import Nav from '@/views/Nav.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/authorizedLogin',
    name: 'authorizedLogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/AuthorizedLogin.vue')
  },
  {
    path: '/lease/managerGoodsList/:leaseType',
    name: 'managerGoodsList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/lease/managerGoodsList.vue')
  },
  {
    path: '/',
    name: 'Nav',
    component: Nav,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
      },
      {
        path: 'article',
        name: 'article',
        component: () => import(/* webpackChunkName: "about" */ '../views/article.vue')
      },
      {
        path: 'order/boothOrder',
        name: 'boothOrder',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/order/boothOrder.vue')
      },
      {
        path: 'order/boothOrder/info',
        name: 'boothOrderInfo',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/order/boothOrderInfo.vue')
      },
      {
        path: 'order/leaseOrder/:leaseType',
        name: 'leaseOrder',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/order/leaseOrder.vue')
      },
      {
        path: 'order/leaseOrder/:leaseType/info',
        name: 'leaseOrderInfo',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/order/leaseOrderInfo.vue')
      },
      {
        path: 'lease/goodsList',
        name: 'goodsList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/lease/goodsList.vue')
      },

      {
        path: 'lease/cartList',
        name: 'cartList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/lease/cartList.vue')
      },
      {
        path: 'lease/batchCartList',
        name: 'batchCartList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/lease/batchCartList.vue')
      },
      
      {
        path: 'lease/checkout',
        name: 'leaserCheckout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/lease/checkout.vue')
      },
      {
        path: 'help',
        name: 'help',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/help.vue')
      },
      {
        path: 'mbr',
        name: 'memberCenter',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/memberCenter.vue')
      },
      {
        path: 'reviewDrawings',
        name: 'reviewDrawings',
        meta: {
          keepAlive: false
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/reviewDrawings/index.vue')
      },
      {
        path: 'drawingsBoothConfirm',
        name: 'drawingsBoothConfirm',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/reviewDrawings/drawingsBoothConfirm.vue')
      },
      {
        path: 'exhibitionBooth',
        name: 'exhibitionBooth',

        component: () => import('../views/reviewDrawings/exhibitionBooth.vue')
      },
      {
        path: 'deposit',
        name: 'deposit',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/deposit/deposit.vue')
      },
      {
        path: 'invoice',
        name: 'invoice',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/deposit/invoice.vue')
      },
      {
        path: 'invoiceList',
        name: 'invoiceList',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/deposit/invoiceList.vue')
      },
      {
        path: 'reportRecord',
        name: 'reportRecord',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/reportRecord.vue')
      },
      {
        path: 'feeSchedule',
        name: 'feeSchedule',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/fixedPayment/feeSchedule.vue')
      },
      {
        path: 'fixedPayment',
        name: 'fixedPayment',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/fixedPayment/fixedPayment.vue')
      },
      {
        path: 'confimOrder',
        name: 'confimOrder',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/fixedPayment/confimOrder.vue')
      },
      {
        path: 'checkout',
        name: 'checkout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/fixedPayment/checkout.vue')
      },
      {
        path: 'reportRecordDtl',
        name: 'reportRecordDtl',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/reportRecordDtl.vue')
      },
      {
        path: 'invoiceRefund',
        name: 'invoiceRefund',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/invoiceRefund/index.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/test',
    name: 'test',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/test.vue')
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login/resetPassword.vue')
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login/register.vue')
  },
  {
    path: '/managerLogin',
    name: 'managerLogin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/manager/managerLogin.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "about" */ '../views/errorPage/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (
    to.path !== '/home' &&
    to.path !== '/login' &&
    to.path !== '/register' &&
    to.path !== '/resetPassword' &&
    !store.state.user.token &&
    to.path !== '/authorizedLogin'
  ) {
    next('/login')
  } else {
    next()
  }
})
export default router
